import React, { memo } from "react";
import EnableNotificationsDialog from "./EnableNotificationsDialog/EnableNotificationsDialog";
import PwaInstallationDialog from "./PwaInstallationDialog";
import {
  FunctionWithVoidReturn,
  ThemeVariant,
} from "../../utils/constants/generic-types";
import { EnableNotificationsSteps } from "../../hooks/useNotifications";

interface NotificationFlowProps {
  saveHyperDialogTheme?: ThemeVariant;
  handleNotifyMe: () => Promise<void>;
  handleGetApp: FunctionWithVoidReturn;
  enableNotificationsStep: EnableNotificationsSteps;
  isEnableNotificationsDialogOpen: boolean;
  isPwaInstallationDialogOpen: boolean;
  openEnableNotificationsDialog: () => void;
  closePwaInstallationDialog: () => void;
  closeEnableNotificationsDialog: () => void;
}

function NotificationFlow({
  saveHyperDialogTheme,
  handleNotifyMe,
  handleGetApp,
  enableNotificationsStep,
  isEnableNotificationsDialogOpen,
  closeEnableNotificationsDialog,
  isPwaInstallationDialogOpen,
  closePwaInstallationDialog,
}: NotificationFlowProps) {
  return (
    <>
      <PwaInstallationDialog
        isOpen={isPwaInstallationDialogOpen}
        onClose={closePwaInstallationDialog}
        saveHyperDialogTheme={saveHyperDialogTheme}
      />

      <EnableNotificationsDialog
        isOpen={false}
        onClose={closeEnableNotificationsDialog}
        handleNotifyMe={handleNotifyMe}
        handleGetApp={handleGetApp}
        enableNotificationsStep={enableNotificationsStep}
      />
    </>
  );
}

export default memo(NotificationFlow);
